/**
 * eMDF.BackOffice.API - Shared
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { DocumentWithDetailsDto } from '../model/document-with-details-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class EmailApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint post /api/v{version}/t/{tenantKey}/email/sendmailcontact/fo
     * @param version 
     * @param tenantKey 
     * @param attachedDocument 
     * @param compteId 
     * @param affaireId 
     * @param isCCMe 
     * @param sender 
     * @param receiver 
     * @param subject 
     * @param body 
     * @param ccReceivers 
     * @param mailsCarpaFrom 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public sendMailFromContactFO(version: string, tenantKey: string, attachedDocument?: Array<DocumentWithDetailsDto>, compteId?: string, affaireId?: string, isCCMe?: boolean, sender?: string, receiver?: string, subject?: string, body?: string, ccReceivers?: Array<string>, mailsCarpaFrom?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<boolean>;
    public sendMailFromContactFO(version: string, tenantKey: string, attachedDocument?: Array<DocumentWithDetailsDto>, compteId?: string, affaireId?: string, isCCMe?: boolean, sender?: string, receiver?: string, subject?: string, body?: string, ccReceivers?: Array<string>, mailsCarpaFrom?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<boolean>>;
    public sendMailFromContactFO(version: string, tenantKey: string, attachedDocument?: Array<DocumentWithDetailsDto>, compteId?: string, affaireId?: string, isCCMe?: boolean, sender?: string, receiver?: string, subject?: string, body?: string, ccReceivers?: Array<string>, mailsCarpaFrom?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<boolean>>;
    public sendMailFromContactFO(version: string, tenantKey: string, attachedDocument?: Array<DocumentWithDetailsDto>, compteId?: string, affaireId?: string, isCCMe?: boolean, sender?: string, receiver?: string, subject?: string, body?: string, ccReceivers?: Array<string>, mailsCarpaFrom?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling sendMailFromContactFO.');
        }
        if (tenantKey === null || tenantKey === undefined) {
            throw new Error('Required parameter tenantKey was null or undefined when calling sendMailFromContactFO.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (attachedDocument) {
            attachedDocument.forEach((element) => {
                localVarFormParams = localVarFormParams.append('AttachedDocument', <any>element) as any || localVarFormParams;
            })
        }
        if (compteId !== undefined) {
            localVarFormParams = localVarFormParams.append('CompteId', <any>compteId) as any || localVarFormParams;
        }
        if (affaireId !== undefined) {
            localVarFormParams = localVarFormParams.append('AffaireId', <any>affaireId) as any || localVarFormParams;
        }
        if (isCCMe !== undefined) {
            localVarFormParams = localVarFormParams.append('IsCCMe', <any>isCCMe) as any || localVarFormParams;
        }
        if (sender !== undefined) {
            localVarFormParams = localVarFormParams.append('Sender', <any>sender) as any || localVarFormParams;
        }
        if (receiver !== undefined) {
            localVarFormParams = localVarFormParams.append('Receiver', <any>receiver) as any || localVarFormParams;
        }
        if (subject !== undefined) {
            localVarFormParams = localVarFormParams.append('Subject', <any>subject) as any || localVarFormParams;
        }
        if (body !== undefined) {
            localVarFormParams = localVarFormParams.append('Body', <any>body) as any || localVarFormParams;
        }
        if (ccReceivers) {
            ccReceivers.forEach((element) => {
                localVarFormParams = localVarFormParams.append('CcReceivers', <any>element) as any || localVarFormParams;
            })
        }
        if (mailsCarpaFrom) {
            mailsCarpaFrom.forEach((element) => {
                localVarFormParams = localVarFormParams.append('MailsCarpaFrom', <any>element) as any || localVarFormParams;
            })
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v${this.configuration.encodeParam({name: "version", value: version, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/t/${this.configuration.encodeParam({name: "tenantKey", value: tenantKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/email/sendmailcontact/fo`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/v{version}/t/{tenantKey}/email/sendmailwithdocuments
     * @param version 
     * @param tenantKey 
     * @param attachedDocument 
     * @param evenementId 
     * @param courrierId 
     * @param sender 
     * @param receiver 
     * @param subject 
     * @param body 
     * @param ccReceivers 
     * @param mailsCarpaFrom 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public sendMailWithDocuments(version: string, tenantKey: string, attachedDocument?: Array<DocumentWithDetailsDto>, evenementId?: string, courrierId?: string, sender?: string, receiver?: string, subject?: string, body?: string, ccReceivers?: Array<string>, mailsCarpaFrom?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<boolean>;
    public sendMailWithDocuments(version: string, tenantKey: string, attachedDocument?: Array<DocumentWithDetailsDto>, evenementId?: string, courrierId?: string, sender?: string, receiver?: string, subject?: string, body?: string, ccReceivers?: Array<string>, mailsCarpaFrom?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<boolean>>;
    public sendMailWithDocuments(version: string, tenantKey: string, attachedDocument?: Array<DocumentWithDetailsDto>, evenementId?: string, courrierId?: string, sender?: string, receiver?: string, subject?: string, body?: string, ccReceivers?: Array<string>, mailsCarpaFrom?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<boolean>>;
    public sendMailWithDocuments(version: string, tenantKey: string, attachedDocument?: Array<DocumentWithDetailsDto>, evenementId?: string, courrierId?: string, sender?: string, receiver?: string, subject?: string, body?: string, ccReceivers?: Array<string>, mailsCarpaFrom?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling sendMailWithDocuments.');
        }
        if (tenantKey === null || tenantKey === undefined) {
            throw new Error('Required parameter tenantKey was null or undefined when calling sendMailWithDocuments.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (attachedDocument) {
            attachedDocument.forEach((element) => {
                localVarFormParams = localVarFormParams.append('AttachedDocument', <any>element) as any || localVarFormParams;
            })
        }
        if (evenementId !== undefined) {
            localVarFormParams = localVarFormParams.append('evenementId', <any>evenementId) as any || localVarFormParams;
        }
        if (courrierId !== undefined) {
            localVarFormParams = localVarFormParams.append('courrierId', <any>courrierId) as any || localVarFormParams;
        }
        if (sender !== undefined) {
            localVarFormParams = localVarFormParams.append('Sender', <any>sender) as any || localVarFormParams;
        }
        if (receiver !== undefined) {
            localVarFormParams = localVarFormParams.append('Receiver', <any>receiver) as any || localVarFormParams;
        }
        if (subject !== undefined) {
            localVarFormParams = localVarFormParams.append('Subject', <any>subject) as any || localVarFormParams;
        }
        if (body !== undefined) {
            localVarFormParams = localVarFormParams.append('Body', <any>body) as any || localVarFormParams;
        }
        if (ccReceivers) {
            ccReceivers.forEach((element) => {
                localVarFormParams = localVarFormParams.append('CcReceivers', <any>element) as any || localVarFormParams;
            })
        }
        if (mailsCarpaFrom) {
            mailsCarpaFrom.forEach((element) => {
                localVarFormParams = localVarFormParams.append('MailsCarpaFrom', <any>element) as any || localVarFormParams;
            })
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v${this.configuration.encodeParam({name: "version", value: version, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/t/${this.configuration.encodeParam({name: "tenantKey", value: tenantKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/email/sendmailwithdocuments`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
